import React, {useEffect, useState} from 'react';
import i18n from '../../i18n';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import FormField from '../Form/FormField';
import Grid from '@material-ui/core/Grid/Grid';
import DeleteButton from '../Form/DeleteButton';
import FormSelect from '../Form/FormSelect';
import FormAutocompleteGQL from '../Form/FormAutocompleteGQL';
import contactQueries from "../../queries/contactQueries";
import buildingQueries from "../../queries/buildingQueries";
import {calculateDate, getSelectOptionEntity} from '../Form/utils';

const FormFields = (props) => {
    /**
     * @param values
     * @param touched
     * @param errors
     * @param handleChange
     * @param handleBlur
     * @param setFieldValue
     * @param classes
     * @param formUrl
     * @param isSubmitting
     * @param props
     */
    const {
        values,
        touched,
        errors,
        handleChange,
        handleBlur,
        setFieldValue,
        isSubmitting,
    } = props;

    const multipleBuildings = true;

    const [subordinates,setSubordinates] = useState(values.building
        ? values.building.children
        : []
    );

    const [warrantyStart,setWarrantyStart] = useState(values.warranty_period_start ? values.warranty_period_start.substring(0, 10) : '');
    const [warrantyEnd,setWarrantyEnd] = useState(values.warranty_period_end ? values.warranty_period_end.substring(0, 10) : '');

    const calculateWarrantyEnd = (date) =>{
        let calculated = calculateDate(date,
            'add',
            5,
            'years',
            'warranty_period_end');
        setWarrantyEnd(calculated);
        setFieldValue('warranty_period_end',calculated);
    }

    useEffect(() =>{
        if(!isSubmitting) {
            setFieldValue('buildingsTrash',values.buildings);
        }
    },[isSubmitting]);

    return (
        <React.Fragment>
            <Grid container spacing={8}>

                <Grid item xs={12}>
                    <FormAutocompleteGQL
                        query={contactQueries.findSubcontractor}
                        labelName={'company_name'}
                        valueName={'id'}
                        name="contact_id"
                        label={i18n.get('project.deficiency.subcontractor')}
                        isClearable={true}
                        mutateData={(data) => {
                            return data.company_name;
                        }}
                        onBlur={handleBlur}
                        onChange={selectedOption => {
                            setFieldValue('contact_id', selectedOption ? selectedOption.value : '');
                            setFieldValue('contact', selectedOption ? selectedOption.entity : null);
                        }}
                        value={values.contact && getSelectOptionEntity(values.contact,'company_name')}
                        error={errors.contact_id}
                        touched={touched.contact_id}
                        likeLeft
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <FormField
                        type="date"
                        name="date_of_contract"
                        label={i18n.get('contract.form.date_contract_conclusion')}
                        error={errors.date_of_contract}
                        touched={touched.date_of_contract}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        defaultValue={values.date_of_contract.substring(0, 10)}
                        InputLabelProps={{shrink: true}}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormField
                        type="date"
                        name="warranty_period_start"
                        label={i18n.get('contract.form.warranty_period_start')}
                        onChange={e => {
                            let value = e.target.value;
                            setFieldValue('warranty_period_start',value)
                            setWarrantyStart(value);
                            calculateWarrantyEnd(value);
                            calculateDate(value,
                                'add',
                                5,
                                'years',
                                'warranty_period_end');
                        }}
                        onBlur={handleBlur}
                        error={errors.warranty_period_start}
                        touched={touched.warranty_period_start}
                        value={warrantyStart}
                        InputLabelProps={{shrink: true}}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormField
                        type="date"
                        name="warranty_period_end"
                        label={i18n.get('contract.form.warranty_period_end')}
                        error={errors.warranty_period_end}
                        touched={touched.warranty_period_end}
                        onChange={e => {
                            setFieldValue('warranty_period_end',e.target.value);
                            setWarrantyEnd(e.target.value);
                        }}
                        onBlur={handleBlur}
                        value={warrantyEnd}
                        InputLabelProps={{shrink: true}}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormAutocompleteGQL
                        query={buildingQueries.findParentBuildings}
                        labelName={'name'}
                        valueName={'id'}
                        name={'building_id'}
                        label={i18n.get('building.construction_project')}
                        isClearable={true}
                        error={errors.building_id}
                        touched={touched.building_id}
                        onChange={selectedOption => {
                            if(selectedOption) {
                                setFieldValue('building_id', selectedOption.value);
                                setFieldValue('building', selectedOption.entity);
                                setSubordinates(selectedOption.entity.children || []);
                            } else {
                                setFieldValue('building_id', '');
                                setFieldValue('building', null);
                                setSubordinates([]);
                            }
                        }}
                        value={values.building && getSelectOptionEntity(values.building)}
                        likeLeft
                    >
                    </FormAutocompleteGQL>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormSelect
                        type="text"
                        name="buildings"
                        label={i18n.get('building.self_selection') + (` (${subordinates.length})` || '')}
                        error={errors.buildings}
                        touched={touched.buildings}
                        onChange={selectedOption => {
                            if(selectedOption) {
                                setFieldValue('buildings', multipleBuildings ? selectedOption : [selectedOption]);
                            } else {
                                setFieldValue('buildings', []);
                            }
                        }}
                        options={subordinates.map(sub => {
                            let label = sub.name;
                            label += sub.street ? ', ' + sub.street : '';
                            label += sub.number ? ' ' + sub.number : '';

                            return {
                                label: label,
                                value: sub.id,
                            }
                        })}
                        value={!multipleBuildings && (values.buildings && values.buildings.length ? values.buildings[0].value : null) }
                        defaultValue={multipleBuildings && values.buildings}
                        placeholder={values.building_child_trashed
                            ? '* ' + i18n.get('building.msg.deleted',{name: values.building_child_trashed})
                            : ( subordinates.length
                                ? i18n.get('building.please_select')
                                : i18n.get('building.no_object_available') )}
                        isClearable={!multipleBuildings}
                        closeMenuOnSelect={!multipleBuildings}
                        multiple={multipleBuildings}
                    />
                </Grid>
            </Grid>

            {props.children}

            <Grid container spacing={24} justify="space-between"
                  alignItems="center"
                  style={{paddingTop: 8}}>
                <Grid item>
                    {values.id > 0 && (
                        <DeleteButton
                            disabled={isSubmitting}
                            href={`/contract/${values.id}`}
                            confirmMessage={i18n.get(
                                'contacts.confirm_message')}
                            successMessage={i18n.get(
                                'contacts.delete_success_message')}
                            handleSuccess={() => {
                                history.go(-1);
                            }}
                        />
                    )}
                </Grid>
                <Grid item>
                    <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={isSubmitting}
                    >
                        <Icon fontSize="small">save</Icon>
                        &nbsp;
                        {i18n.get('contract.actions.save')}
                    </Button>
                </Grid>
            </Grid>
        </React.Fragment>
    )
};

export default FormFields;
